import React from 'react';

import cn from 'classnames';
import DropdownItem from '../../DropdownItem';
import { dropdownItems } from '../../Content';

// import styles from '../../AnnouncementBanner/AnnouncementBanner.module.css';

const ProductsDropdown = ({ theme, dropdown, navResponsive }) => (
  <div className="flex gap-12 pt-10 pb-12 3xl:gap-16 px-14" data-first-dropdown-section>
    <div className="flex-shrink-0 min-w-max">
      <h4 className="mb-8 text-base font-medium leading-6 text-scale-skyblue">
        {dropdownItems[dropdown].section1.title}
      </h4>

      {dropdownItems[dropdown].section1.row1.title && (
        <h5
          className={cn(
            'mb-5 text-sm leading-6 font-normal text-neutral-300',
            textTheme[theme.theme]
          )}
        >
          {dropdownItems[dropdown].section1.row1.title}
        </h5>
      )}
      <ul className="flex flex-col gap-6">
        {dropdownItems[dropdown].section1.row1.content.map(item => (
          <DropdownItem
            key={item.title}
            href={item.href}
            icon={item.icon}
            title={item.title}
            text={item.text}
            colors={theme.dropdown.items}
            itemType={item.type}
            navResponsive={navResponsive}
          />
        ))}
      </ul>

      <div className="flex-shrink-0 pl-16 mt-4">
        <h5
          className={cn(
            'mb-5 text-sm leading-6 font-normal text-neutral-300',
            textTheme[theme.theme]
          )}
        >
          {dropdownItems[dropdown].section1.row2.title}
        </h5>
        <ul className="flex flex-col gap-6">
          {dropdownItems[dropdown].section1.row2.subContent.map(item => (
            <DropdownItem
              key={item.title}
              href={item.href}
              icon={item.icon}
              title={item.title}
              text={item.text}
              colors={theme.dropdown.items}
              itemType={item.type}
              navResponsive={navResponsive}
            />
          ))}
        </ul>
      </div>
    </div>

    <div className="flex-shrink-0 min-w-max">
      <h4 className="mb-8 font-medium text-scale-lightmauve">
        {dropdownItems[dropdown].section2.title}
      </h4>
      {dropdownItems[dropdown].section2.row1.title && (
        <h5
          className={cn(
            'mb-5 text-sm leading-6 font-normal text-neutral-300',
            textTheme[theme.theme]
          )}
        >
          {dropdownItems[dropdown].section2.row1.title}
        </h5>
      )}
      <ul className="flex flex-col gap-6">
        {dropdownItems[dropdown].section2.row1.content.map(item => (
          <DropdownItem
            key={item.title}
            href={item.href}
            icon={item.icon}
            title={item.title}
            text={item.text}
            colors={theme.dropdown.items}
            itemType={item.type}
            navResponsive={navResponsive}
          />
        ))}
      </ul>

      <div className="flex-shrink-0 pl-16 mt-4">
        <h5
          className={cn(
            'mb-5 text-sm leading-6 font-normal text-neutral-300',
            textTheme[theme.theme]
          )}
        >
          {dropdownItems[dropdown].section2.row2.title}
        </h5>
        <ul className="flex flex-col gap-6">
          {dropdownItems[dropdown].section2.row2.subContent.map(item => (
            <DropdownItem
              key={item.title}
              href={item.href}
              icon={item.icon}
              title={item.title}
              text={item.text}
              colors={theme.dropdown.items}
              itemType={item.type}
              navResponsive={navResponsive}
            />
          ))}
        </ul>
      </div>

      <div className="flex-shrink-0 mt-12">
        {dropdownItems[dropdown].section2.row3.title && (
          <h5
            className={cn(
              'mb-5 text-sm leading-6 font-normal text-neutral-300',
              textTheme[theme.theme]
            )}
          >
            {dropdownItems[dropdown].section2.row3.title}
          </h5>
        )}
        <ul className="flex flex-col gap-6">
          {dropdownItems[dropdown].section2.row3.content.map(item => (
            <DropdownItem
              key={item.title}
              href={item.href}
              icon={item.icon}
              title={item.title}
              text={item.text}
              colors={theme.dropdown.items}
              itemType={item.type}
              navResponsive={navResponsive}
            />
          ))}
        </ul>
      </div>
    </div>

    <div className="flex-shrink-0 min-w-max">
      <h4 className="mb-8 font-medium text-scale-periwinkle">
        {dropdownItems[dropdown].section3.title}
      </h4>

      {dropdownItems[dropdown].section3.row1.title && (
        <h5
          className={cn(
            'mb-5 text-sm leading-6 font-normal text-neutral-300',
            textTheme[theme.theme]
          )}
        >
          {dropdownItems[dropdown].section3.row1.title}
        </h5>
      )}
      <ul className="flex flex-col gap-6">
        {dropdownItems[dropdown].section3.row1.content.map(item => (
          <DropdownItem
            key={item.title}
            href={item.href}
            icon={item.icon}
            title={item.title}
            text={item.text}
            colors={theme.dropdown.items}
            itemType={item.type}
            navResponsive={navResponsive}
          />
        ))}
      </ul>
    </div>
  </div>
);

const textTheme = {
  dark: 'text-neutral-400',
  light: 'text-neutral-400'
};

ProductsDropdown.defaultProps = {
  dropdown: 'products',
  navResponsive: false
};

export default ProductsDropdown;
